export default {
  state: {
    map: null,
    filter: {
      connectionType: ['chademo', 'type2ccs', 'type2ac', 'type1ac'],
      freePaid: ['free', 'paid', 'unknown'],
      chargerSpeed: ['fast', 'medium', 'Under Construction', 'Future']
    }
  },
  mutations: {
    mapInitialized (state, payload) {
      state.map = payload
      console.log('Mutation: map/mapInitialized')
    },
    setConnectionType (state, payload) {
      state.filter.connectionType = payload
      console.log('Mutation: map/setConnectionType')
    },
    setFreePaid (state, payload) {
      state.filter.freePaid = payload
      console.log('Mutation: map/setFreePaid')
    },
    setChargerSpeed (state, payload) {
      state.filter.chargerSpeed = payload
      console.log('Mutation: map/setChargerSpeed')
    }
  },
  actions: {

  },
  namespaced: true
}
